import { useTranslation } from "react-i18next";
import { useUserContext } from "../../context/user.context";
import React, { useEffect, useState } from "react";

export const DASHBOARD_MENU = () => {
  const {t} = useTranslation();
  const { isGlobalUserAdmin, isUserAdmin, isCampaignManager, isAnalyst, isDeviceManager, isPOSManager, merchantId } = useUserContext();
  const [globalAdmin, setGlobalAdmin] = useState(false);
  const [userAdmin, setUserAdmin] = useState(false);
  const [campaignManager, setCampaignManager] = useState(false);
  const [accountant, setAccountatnt] = useState(false);
  const [deviceManager, setDeviceManager] = useState(false);
  const [POSManager, setPOSManager] = useState(false);

  useEffect(() => {
    if (isGlobalUserAdmin) {
      setGlobalAdmin(true);
    } else {
      setGlobalAdmin(false);
    }
    if (isUserAdmin) {
      setUserAdmin(true);
    } else {
      setUserAdmin(false);
    }
    if (isCampaignManager) {
      setCampaignManager(true);
    } else {
      setCampaignManager(false);
    }
    if (isAnalyst) {
      setAccountatnt(true);
    } else {
      setAccountatnt(false);
    }
    if (isDeviceManager) {
      setDeviceManager(true);
    } else {
      setDeviceManager(false);
    }
    if (isPOSManager) {
      setPOSManager(true);
    } else {
      setPOSManager(false);
    }
    
  }, [isGlobalUserAdmin, isUserAdmin, isCampaignManager, isAnalyst, isDeviceManager, isPOSManager, merchantId]);

  //console.log("IS GLOBAL ADMIN OR CAMPAIGN => ", globalAdmin, userAdmin, campaignManager, accountant, deviceManager);

  return [
    {
      menutitle: `${t("sideBar.dashboard")}`,
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/payments/dashboard`,
          icon: "ti-stats-up",
          type: "link",
          active: false,
          selected: false,
          title: `${t("sideBar.paymentOverview")}`,
          highlighted: globalAdmin || userAdmin || accountant,
          children: [],
          disabled: !globalAdmin && !userAdmin && !accountant,
        },
        {
          path: `${process.env.PUBLIC_URL}/performance/dashboard`,
          icon: "ti-bar-chart",
          type: "link",
          active: false,
          selected: false,
          title: `${t("sideBar.performanceOverview")}`,
          highlighted: globalAdmin || userAdmin || accountant,
          children: [],
          disabled: !globalAdmin && !userAdmin && !accountant,
        },
      ],
    },
    {
      menutitle: `${t("sideBar.reports")}`,
      Items: [
        /* {
				  disabled: true,
				  path: `${process.env.PUBLIC_URL}/Payments`,
				  title: 'Payments',
				  icon: 'ti-money',
				  type: 'link',
				  active: false,
				  selected: false,
				  children: []
			  }, */
        /* {
          path: `${process.env.PUBLIC_URL}/Transactions`,
          title: "Transactions",
          icon: "ti-pulse",
          type: "link",
          active: false,
          selected: false,
          highlighted: globalAdmin || userAdmin || accountant,
          children: [],
          disabled: !globalAdmin && !userAdmin && !accountant,
        }, */
        {
          path: `${process.env.PUBLIC_URL}/PagingTransaction`,
          title: `${t("sideBar.Transactions")}`,
          icon: "ti-pulse",
          type: "link",
          active: false,
          selected: false,
          highlighted: globalAdmin || userAdmin || accountant,
          children: [],
          disabled: !globalAdmin && !userAdmin && !accountant,
        },
        {
          path: `${process.env.PUBLIC_URL}/Reporter`,
          title: `${t("sideBar.Reporter")}`,
          icon: "ti-receipt",
          type: "link",
          active: false,
          selected: false,
          highlighted: globalAdmin || userAdmin || accountant,
          children: [],
          disabled: !globalAdmin && !userAdmin && !accountant,
        },
        /* {
				  disabled: true,
				  path: `${process.env.PUBLIC_URL}/Purchases`,
				  title: 'Purchases',
				  icon: 'ti-shopping-cart',
				  type: 'link',
				  active: false,
				  selected: false,
				  children: []
			  },
			  {
				  disabled: true,
				  path: `${process.env.PUBLIC_URL}/POS`,
				  title: 'POS',
				  icon: 'ti-tablet',
				  type: 'link',
				  active: false,
				  selected: false,
				  children: []
			  }, */
      ],
    },

    /* {
		menutitle: 'RESEARCH',
		Items: [
			{
				path: `${process.env.PUBLIC_URL}/Search`,
				icon: 'ti-pulse',
				type: 'link',
				active: false,
				selected: false,
				title: 'Advanced Search',
				disabled: true
			},
		]
	}, */

    /* {
		menutitle: 'FINANCIAL',
		Items: [
			{
				disabled: true,
				path: `${process.env.PUBLIC_URL}/Wallet`,
				icon: 'ti-wallet',
				type: 'link',
				active: false,
				selected: false,
				title: 'Money Wallet'
			},
		]
	}, */
    {
      menutitle: `${t("sideBar.campaigns")}`,
      Items: [
        {
          title: `${t("sideBar.vouchers")}`,
          icon: "ti-ticket",
          type: "sub",
          active: false,
          highlighted: globalAdmin || userAdmin || campaignManager,
          disabled: !globalAdmin && !userAdmin && !campaignManager,
          selected: false,
          children: [
            {
              disabled: !globalAdmin && !userAdmin && !campaignManager,
              path: `${process.env.PUBLIC_URL}/ActiveCampaigns`,
              icon: "ti-ticket",
              type: "link",
              active: false,
              selected: false,
              title: `${t("sideBar.activeCampaigns")}`,
              highlighted: false,
            },
            {
              disabled: !globalAdmin && !userAdmin && !campaignManager,
              path: `${process.env.PUBLIC_URL}/CampaignTools`,
              icon: `${t("sideBar.campaignTool")}`,
              type: "link",
              active: false,
              selected: false,
              title: "Campaign tools",
              highlighted: false,
            },
          ],
        },
      ],
    },
    {
      menutitle: `${t("sideBar.locations")}`,
      Items: [
        /* {
				disabled: true,
				path: `${process.env.PUBLIC_URL}/Products`,
				title: 'Products',
				icon: 'ti-package',
				type: 'link',
				active: false,
				selected: false,
				children: []
			}, */
        {
          title: `${t("sideBar.devices")}`,
          icon: "ti-vector",
          type: "sub",
          active: false,
          selected: false,
          highlighted: globalAdmin || userAdmin || deviceManager,
          disabled: !globalAdmin && !userAdmin && !deviceManager,
          children: [
            /* {
              disabled: !globalAdmin && !userAdmin && !deviceManager,
              path: `${process.env.PUBLIC_URL}/Devices`,
              type: "link",
              active: false,
              selected: false,
              title: "Overview",
              highlighted: true,
            }, */
            {
              disabled: !globalAdmin && !userAdmin && !deviceManager,
              path: `${process.env.PUBLIC_URL}/Overview`,
              type: "link",
              active: false,
              selected: false,
              title: `${t("sideBar.overview")}`,
              highlighted: true,
            },
            {
              disabled: !globalAdmin && !userAdmin && !deviceManager,
              path: `${process.env.PUBLIC_URL}/Overview/setup`,
              type: "link",
              active: false,
              selected: false,
              title: `${t("sideBar.setup")}`,
              highlighted: true,
            },
            {
              disabled: !globalAdmin && !userAdmin && !deviceManager,
              path: `${process.env.PUBLIC_URL}/Overview/Management`,
              type: "link",
              active: false,
              selected: false,
              title: `${t("sideBar.management")}`,
              highlighted: true,
            }
          ],
        },
        {
          title: `${t("sideBar.POS")}`,
          icon: "ti-vector",
          type: "sub",
          active: false,
          selected: false,
          highlighted: globalAdmin || userAdmin || POSManager,
          disabled: !globalAdmin && !userAdmin && !POSManager,
          children: [
            /* {
              disabled: !globalAdmin && !userAdmin && !deviceManager,
              path: `${process.env.PUBLIC_URL}/Devices`,
              type: "link",
              active: false,
              selected: false,
              title: "Overview",
              highlighted: true,
            }, */
            {
              disabled: !globalAdmin && !userAdmin && !POSManager,
              path: `${process.env.PUBLIC_URL}/POSOverview`,
              type: "link",
              active: false,
              selected: false,
              title: `${t("sideBar.POSOverview")}`,
              highlighted: true,
            },
            {
              disabled: !globalAdmin && !userAdmin && !POSManager,
              path: `${process.env.PUBLIC_URL}/POSOverview/setup`,
              type: "link",
              active: false,
              selected: false,
              title: `${t("sideBar.POSSetup")}`,
              highlighted: true,
            },
          ],
        },
      ],
    },
  ];
};

export const TEST_MENU_ITEMS = [
  {
    menutitle: "HOME TEST",
    Items: [
      {
        title: "HOME - highlighted",
        path: `${process.env.PUBLIC_URL}/Transactions`,
        icon: "ti-home",
        type: "link",
        active: false,
        selected: false,
        badge: "badge bg-info side-badge",
        badgetxt: "text",
        highlighted: true,
      },
      {
        title: "TEST2",
        icon: "ti-home",
        type: "sub",
        active: false,
        selected: false,
        badge: "badge bg-warning side-badge",
        badgetxt: "70",
        disabled: false,
        children: [
          {
            title: "Performance overview",
            path: `${process.env.PUBLIC_URL}/performance/dashboard`,
            type: "link",
            active: false,
            selected: false,
          },
          {
            title: "Payments overview",
            path: `${process.env.PUBLIC_URL}/payments/dashboard`,
            type: "link",
            active: false,
            selected: false,
          },
        ],
      },
    ],
  },
  {
    menutitle: "DISABLED TEST",
    Items: [
      {
        title: "DISABLED",
        path: `${process.env.PUBLIC_URL}/Devices`,
        icon: "ti-home",
        type: "link",
        active: false,
        selected: false,
        disabled: true,
      },
    ],
  },
  {
    menutitle: "SIDEBAR TEST 2",
    Items: [
      {
        title: "LEVEL 1 SUB",
        icon: "ti-home",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            type: "sub",
            active: false,
            selected: false,
            title: "LEVEL 2 SUB",
            children: [
              {
                title: "LEVEL 2 - CHILD LINK 1",
                path: `${process.env.PUBLIC_URL}/payments/dashboard`,
                type: "link",
                active: false,
                selected: false,
              },
              {
                title: "LEVEL 2 - CHILD LINK 2",
                path: `${process.env.PUBLIC_URL}/performance/dashboard`,
                type: "link",
                active: false,
                selected: false,
              },
            ],
          },
          {
            title: "LEVEL 2 LINK",
            path: `${process.env.PUBLIC_URL}/payments/dashboard`,
            type: "link",
            active: false,
            selected: false,
          },
        ],
      },
      {
        title: "LEVEL 1 LINK",
        path: `${process.env.PUBLIC_URL}/performance/dashboard`,
        icon: "ti-home",
        type: "link",
        active: false,
        selected: false,
      },
    ],
  },
];
